import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import ROUTES from '@giro-pdv/constants/routes.constant';
import useProtectedByAuth from '@giro-pdv/hooks/useProtectedByAuth.hook';
import AppLayout from '@giro-pdv/layouts/App.layout';

import PaymentLinksScreen from './screens/PaymentLinks.screen';

const PaymentLinksModule = () => {
  useProtectedByAuth();

  return (
    <AppLayout fullHeight maxWidth={false}>
      <Switch>
        <Route
          exact
          path={ROUTES.PAYMENT_LINKS.ROOT}
          component={PaymentLinksScreen}
        />
        <Redirect to={ROUTES.PAYMENT_LINKS.ROOT} />
      </Switch>
    </AppLayout>
  );
};

export default PaymentLinksModule;
